var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSewage = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.497 5.286c0-.711-.587-1.286-1.313-1.286s-1.312.575-1.312 1.286v.482l-3.938-.482c-.726 0-1.312.574-1.312 1.285 0 .712.586 1.286 1.312 1.286l5.25-.643 5.25.643c.726 0 1.313-.574 1.313-1.286 0-.71-.587-1.285-1.313-1.285l-3.937.482v-.482zm0 3.383-1.313-.161-1.312.16v1.76h-5.25v10.286h13.125V10.43h-5.25v-1.76zm-10.5.474c-.726 0-1.313.574-1.313 1.286v10.285c0 .711.587 1.286 1.313 1.286s1.312-.575 1.312-1.286V10.43c0-.712-.586-1.286-1.312-1.286zm19.687 1.286c0-.712-.586-1.286-1.312-1.286-.726 0-1.313.574-1.313 1.286v10.285c0 .711.587 1.286 1.313 1.286s1.312-.575 1.312-1.286V10.43z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSewage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sewage.f2997351.svg";
export { ForwardRef as ReactComponent };